/** CV generation (backend path retains historical typo `gererate`). */
export const RESUME_ENDPOINTS = {
  generateApplicantCv: '/rec/resume/gererate-applicant-cv',
} as const;
